import React, { useEffect, useState } from "react";
import {
  Select,
  MenuItem,
  InputAdornment,
  IconButton,
} from "@material-ui/core";
import { getDateRange } from "./getDateRange";
import moment from "moment";
import TextField from "@material-ui/core/TextField";
import {
  DateRangePicker,
  DateRangeDelimiter,
  LocalizationProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@material-ui/pickers/adapter/date-fns"; // choose your lib
import { errorAlert } from "../../../function/alert";
import CalendarToday from "@material-ui/icons/CalendarToday";

export const BasicDateRangePicker = ({
  getCustomDate,
  maxDate,
  disabled,
  value,
  ...props
}) => {
  const [selectedDate, handleDateChange] = React.useState(
    value ? value : [null, null]
  );

  // useEffect(() => {
  //   if (selectedDate.length) {
  //     getCustomDate(selectedDate);
  //   }
  // }, [selectedDate]);

  const setDate = (e) => {
    if ((e.length, e[1])) {
      if (moment(e[0]).isAfter(new Date())) {
        errorAlert("Please select a correct date");
      } else if (moment(e[1]).isAfter(new Date())) {
        errorAlert("Please select a correct date");
      } else {
        handleDateChange(e);
        getCustomDate(e);
      }
    }
  };

  return (
    <LocalizationProvider dateAdapter={DateFnsUtils}>
      <DateRangePicker
        startText="Start Date"
        endText="End Date"
        className="date-ranger-picker-live-reports"
        value={selectedDate}
        onChange={(date) => setDate(date)}
        renderInput={(startProps, endProps) => (
          <>
            <TextField
              {...startProps}
              fullWidth
              onChange={() => {}}
              inputProps={{ ...startProps.inputProps, onChange: () => {} }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      edge="end"
                      color="dark"
                      onClick={startProps.inputProps.onClick}
                    >
                      <CalendarToday />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <DateRangeDelimiter> to </DateRangeDelimiter>
            <TextField
              {...endProps}
              fullWidth
              onChange={() => {}}
              inputProps={{ ...endProps.inputProps, onChange: () => {} }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      edge="end"
                      color="dark"
                      onClick={endProps.inputProps.onClick}
                    >
                      <CalendarToday />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </>
        )}
        maxDate={maxDate}
      />
    </LocalizationProvider>
  );
};

const SelectFilter = ({ onDateChange, excludeOptions, ...props }) => {
  const menuList = [
    { value: "TODAY", label: "Today" },
    { value: "YESTERDAY", label: "Yesterday" },
    { value: "THISWEEK", label: "This Week" },
    { value: "LASTWEEK", label: "Last Week" },
    { value: "LAST30DAYS", label: "Last 30 Days" },
    { value: "THISMONTH", label: "This Month" },
    { value: "LASTMONTH", label: "Last Month" },
    { value: "3MONTHS", label: "3 Months" },
    { value: "6MONTHS", label: "6 Months" },
    { value: "1YEAR", label: "1 Year" },
    { value: "2YEAR", label: "2 Years" },
    { value: "5YEAR", label: "5 Years" },
    { value: "CUSTOM", label: "Custom" },
  ];

  if (excludeOptions) {
    // Exclude "CUSTOM" and "LASTMONTH" options
    menuList.splice(menuList.findIndex((option) => option.value === "CUSTOM"), 1);
    menuList.splice(menuList.findIndex((option) => option.value === "LASTMONTH"), 1);
    menuList.splice(menuList.findIndex((option) => option.value === "LAST30DAYS"), 1);
  }

  const [selected, setSelected] = useState(
    props.defaultSelected || "LAST30DAYS"
  );
  const [helperText, setHelperText] = useState("");
  const [dateQuery, setDateQuery] = useState(null);
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    if (selected === "CUSTOM") {
      setOpenModal(true);
    } else {
      let date = getDateRange(selected);
      setHelperText(date.text);
      setDateQuery(date.query);
      onDateChange(date.query, date.type, selected);
    }
  }, [selected]);

  const handleClose = () => {
    setOpenModal(false);
  };

  const getCustomDate = (data) => {
    if (selected === "CUSTOM") {
      setDateQuery({
        startDate: moment(data[0]).format("YYYY-MM-DD"),
        endDate: moment(data[1]).format("YYYY-MM-DD"),
      });
      setHelperText(
        `${moment(data[0]).format("ll")} - ${moment(data[1]).format("ll")}`
      );
      onDateChange(
        {
          startDate: moment(data[0]).format("YYYY-MM-DD"),
          endDate: moment(data[1]).format("YYYY-MM-DD"),
        },
        "Custom"
      );
      setOpenModal(false);
    }
  };

  const handleChange = (e) => {
    setSelected(e.target.value);
  };

  return (
    <React.Fragment>
      {/* <FormControl variant="outlined" fullWidth key="Select date range">*/}
      {/* <InputLabel id="demo-simple-select-outlined-label">
        
      </InputLabel> */}
      {props?.helperText && (
        <div className="d-flex text-right">
          <div className="f12-400">Report Range Date: </div>
          <div className="f12-500"> {helperText}</div>
        </div>
      )}
      <div className="dateflex">
      <div className="d-flex justify-content-between align-items-center">
        <div className="f10-400 pr-2" style={{ width: "max-content" }}>
          Select Date Range
        </div>
        {/* <FormHelperText>{helperText}</FormHelperText> */}
      </div>
      <Select
        key="Select date range"
        // labelId="demo-simple-select-outlined-label"
        // id="demo-simple-select-outlined"
        value={selected}
        onChange={handleChange}
        // variant="outlined"
        fullWidth
        disableUnderline
        // label="date_range"
        sx={{ fontWeight: "bold" }}
        style={{width:"inherit"}}
      >
        {menuList.map((menu, i) => (
          <MenuItem
            value={menu.value}
            key={i + menu.value}
            sx={{ fontWeight: "bold" }}
          >
            <h5 className="f12-700"> {menu.label} </h5>
          </MenuItem>
        ))}
      </Select>

      {/* </FormControl> */}
      {/*  <Dialog
        open={openModal}
        aria-labelledby="responsive-dialog-title"
        disableEscapeKeyDown={true}
        onBackdropClick={()=>{}}
      >
        <DialogTitle id="responsive-dialog-title">
          {"Select Custom Date Range"}
        </DialogTitle>
        <DialogContent> */}
      <div>
        {selected === "CUSTOM" && (
          <BasicDateRangePicker getCustomDate={getCustomDate} />
        )}
      </div>

      {/* </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog> */}
      </div>

    </React.Fragment>
  );
};

export default SelectFilter;
